import React, { useState } from 'react';
import { Vendor, VendorTrackingDetails } from '../services/vendor/types';
import { API_BASE_URL } from '../services/constants';
import { useExtension } from '../extension';
import { useDeeplinkModal } from '../modal';

interface StoreCardProps {
    store: Vendor;
    index: number;
    trackingDetails: VendorTrackingDetails;
    activateVendor: (campaignId: string) => Promise<VendorTrackingDetails>;
}

const StoreCard = ({ store, index, trackingDetails, activateVendor }: StoreCardProps) => {
    const { openDeepLink } = useExtension();
    const { requestRedirect } = useDeeplinkModal();
    const [expanded, setExpanded] = useState(false);

    const handleRedirectClick = (id: string) => {
        activateVendor(id).then(requestRedirect)
    }

    return (
        <div
            className={`store-card${expanded ? ' expanded' : ''}`}
            style={{ animationDelay: `${0.04 + index * 0.04}s` }}
            data-store-id={store.id}
            onClick={() => requestRedirect(trackingDetails)}
        >
            <img
                src={`${API_BASE_URL}/vendor/logo?uri=${store.logo}`}
                alt={store.name}
                className="store-logo"
            />

            <div className="store-info">
                <div className="store-name">{store.name}</div>
                <div className={`store-description${expanded ? ' expanded' : ''}`}>
                    {store.description}
                </div>
                {store.description?.length > 60 && (
                    <button
                        className="see-more-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setExpanded(prev => !prev);
                        }}
                    >
                        {expanded ? 'See less' : 'See more'}
                    </button>
                )}
            </div>

            <button
                className="activate-btn"
                onClick={() => trackingDetails ? openDeepLink(trackingDetails) : handleRedirectClick(store.id)}
            >
                {trackingDetails ? 'Navigate to store' : 'Activate'}
            </button>
        </div>
    );
}

export default StoreCard;